// @flow
export default (theme: Object) => ({
    MuiIcon: {
        root: { fontSize: 24 },
        fontSizeSmall: { fontSize: 20 },
        fontSizeLarge: { fontSize: 35 },
    },
    MuiSvgIcon: {
        root: { fontSize: 24 },
        fontSizeSmall: { fontSize: 20 },
        fontSizeLarge: { fontSize: 35 },
    },
    MuiTooltip: {
        popper: { width: 'max-content' },
        tooltip: {
            position: 'relative',
            backgroundColor: theme.palette.common.black,
            padding: theme.spacing(1),
            fontSize: theme.typography.pxToRem(14),
            lineHeight: `${theme.typography.round(16 / 14)}em`,

            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(1),
                fontSize: theme.typography.pxToRem(14),
                lineHeight: `${theme.typography.round(16 / 14)}em`,
            },

            '&::before': {
                content: '""',
                position: 'absolute',
            },
        },
        tooltipPlacementLeft: {
            '&::before': {
                top: '50%',
                right: -7,
                marginTop: -7,
                borderTop: [[7, 'solid', 'transparent']],
                borderBottom: [[7, 'solid', 'transparent']],
                borderLeft: [[7, 'solid', theme.palette.common.black]],
            },
        },
        tooltipPlacementRight: {
            '&::before': {
                top: '50%',
                left: -7,
                marginTop: -7,
                borderTop: [[7, 'solid', 'transparent']],
                borderBottom: [[7, 'solid', 'transparent']],
                borderRight: [[7, 'solid', theme.palette.common.black]],
            },
        },
        tooltipPlacementTop: {
            '&::before': {
                bottom: -7,
                left: '50%',
                marginLeft: -7,
                borderLeft: [[7, 'solid', 'transparent']],
                borderRight: [[7, 'solid', 'transparent']],
                borderTop: [[7, 'solid', theme.palette.common.black]],
            },
        },
        tooltipPlacementBottom: {
            '&::before': {
                top: -7,
                left: '50%',
                marginLeft: -7,
                borderLeft: [[7, 'solid', 'transparent']],
                borderRight: [[7, 'solid', 'transparent']],
                borderBottom: [[7, 'solid', theme.palette.common.black]],
            },
        },
    },
    MuiCardHeader: {
        root: {
            width: '100%',
            '&:last-child': { paddingBottom: theme.spacing(2) },
        },
        action: {
            // alignSelf: 'unset',
            // marginTop: 0,
        },
    },
    MuiLinearProgress: {
        secondaryColor: { backgroundColor: theme.palette.grey[300] },
        secondaryColorBar: { backgroundColor: theme.palette.secondary.light },
    },
    MuiAvatar: {
        colorDefault: { backgroundColor: theme.palette.grey[500] },
    },
    MuiChip: {
        root: { backgroundColor: theme.palette.grey[100] },
        label: { fontSize: 14 },
    },
    MuiListItemIcon: {
        root: {
            minWidth: 40,
        },
    },
    MuiBadge: {
        badge: {
            fontFamily: 'Inter',
            fontSize: 11.5,
        },
    },

    /**
     * Override styles applied by gigwalk scss modules (_form.scss, _button.scss, etc)
     * which don't really fit the material design spec
     */
    MuiInput: {
        multiline: {
            '@global textarea': { minHeight: 0 },
        },
        inputMultiline: { minHeight: 0 },
        input: {
            minHeight: 'auto',
            '&:focus': { boxShadow: 'unset' },
        },
    },
    MuiOutlinedInput: {
        multiline: {
            '@global textarea': { minHeight: 0 },
        },
        inputMultiline: { minHeight: 0 },
        input: {
            minHeight: 'auto',
            '&:focus': { boxShadow: 'unset' },
        },
    },
    MuiFilledInput: {
        multiline: {
            '@global textarea': { minHeight: 0 },
        },
        inputMultiline: { minHeight: 0 },
        input: {
            minHeight: 'auto',
            '&:focus': { boxShadow: 'unset' },
        },
    },
    MuiButton: {
        root: {
            textTransform: 'none', // Override uppercase transform
            minWidth: 0,
        },
        containedPrimary: {
            '&:hover': { color: theme.palette.primary.contrastText },
        },
        containedSecondary: {
            '&:hover': { color: theme.palette.secondary.contrastText },
        },
    },
    MuiToggleButton: {
        root: {
            textTransform: 'none', // Override uppercase transform
        },
    },
    MuiFormControlLabel: {
        root: { marginBottom: 'unset' },

        // In material-ui v4, the default Typography variant changed from body2 to body1
        // but I think body2 looks better for selection controls.
        label: {
            fontSize: '0.875rem',
            lineHeight: 1.43,
            letterSpacing: '0.01071em',
        },
    },
    MuiTouchRipple: {
        root: { color: 'rgba(0, 0, 0, 0.87)' },
    },
    MuiListItem: {
        root: {
            '&:focus': { outline: 'none' },
        },
    },
    MuiListItemText: {
        dense: { fontSize: 12.5 },
        primary: {
            fontFamily: 'Inter',
            textTransform: 'none',
        },
        secondary: { fontFamily: 'Inter' },
    },
    MuiDialogContentText: {
        root: {
            marginBottom: [theme.spacing(2), '!important'],
        },
    },
});
